/* eslint-disable @typescript-eslint/no-unsafe-call */

import AsyncStorage from '@react-native-async-storage/async-storage'
import { Alert } from 'react-native'

import global from '../global'
import { Bill, File } from '../types'

function createHeader(token: string | undefined, mandantId?: string) {
  const myHeaders = new Headers()
  token && myHeaders.append('Authorization', token)

  if (mandantId !== '-1' && mandantId !== null && mandantId !== undefined) myHeaders.append('mandantID', mandantId)

  return myHeaders
}

// if the user doesn't want to wait (default) method will return after a
function dontWaitResolve(billID: string, supplierID: string, billDate: string, resolve: any) {
  AsyncStorage.getItem('wait')
    .then(wait => {
      if (wait === 'true') {
        // @ts-ignore todo
        const bill: Bill = { billID, supplierID, billDate }
        global.billBlacklist.push(bill as never)

        resolve('timeout')
      }
    })
    .catch(console.error)
}

const api = {
  getBills(token: string | undefined, url: string | undefined, mandantId: string | undefined) {
    return new Promise<{ data: Bill[] }>((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
      }

      fetch(url + '/Bills', requestOptions)
        .then(response => response.json())
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  getBillDetail(
    token: string | undefined,
    url: string | undefined,
    mandantId: string | undefined,
    billId: string,
    supplierID: string,
    billDate: string
  ) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      myHeaders.append('Content-Type', 'application/json')

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
          BillID: billId,
          SupplierID: supplierID,
          BillDate: billDate,
        }),
      }

      fetch(url + '/Bills/detail', requestOptions)
        .then(response => {
          if (response.status === 200) return response.json()
          throw new Error(response.status.toString())
        })
        .then(result => {
          resolve(result.data)
        })
        .catch(error => {
          console.error(error)
          reject(error)
        })
    })
  },
  getArchive(token: string | undefined, url: string | undefined, mandantId: string | undefined, historyDays = -1) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
      }

      let requestUrl = url + '/Bills/archive'
      if (historyDays !== -1) requestUrl = requestUrl + '/' + historyDays.toString()

      fetch(requestUrl, requestOptions)
        .then(response => response.json())
        .then(resolve)
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  getEmployees(token: string | undefined, url: string | undefined, mandantId: string | undefined) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
      }

      fetch(url + '/Employees', requestOptions)
        .then(response => response.json())
        .then(result => resolve(result.data))
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  getMandants(token: string | undefined, url: string | undefined) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token)

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
      }

      fetch(url + '/mandants', requestOptions)
        .then(response => response.json())
        .then(result => resolve(result.data))
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  getHistory(
    token: string | undefined,
    url: string | undefined,
    mandantId: string | undefined,
    billId: string,
    supplierID: string,
    billDate: string
  ) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)

      myHeaders.append('Content-Type', 'application/json')

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
          BillID: billId,
          SupplierID: supplierID,
          BillDate: billDate,
        }),
      }

      fetch(url + '/Bills/history', requestOptions)
        .then(response => {
          return response.json()
        })
        .then(result => {
          resolve(result.data)
        })
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  getFile(token: string | undefined, url: string | undefined, mandantId: string | undefined, billId: string, supplierID: string, billDate: string) {
    return new Promise<File>((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      myHeaders.append('Content-Type', 'application/json')

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
          BillID: billId,
          SupplierID: supplierID,
          BillDate: billDate,
        }),
      }

      fetch(url + '/Bills/file', requestOptions)
        .then(response => {
          return response.json()
        })
        .then((result: { data: File }) => {
          resolve(result.data)
        })
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  billReturn(
    token: string | undefined,
    url: string | undefined,
    mandantId: string | undefined,
    msgID: string,
    billID: string,
    supplierID: string,
    billDate: string,
    comment: string,
    errormsg: string
  ) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      myHeaders.append('Content-Type', 'application/json')

      const raw = JSON.stringify({
        msgID: msgID,
        billID: billID,
        comment: comment,
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
      }

      dontWaitResolve(billID, supplierID, billDate, resolve)

      fetch(url + '/Bills/return', requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === 'fail') {
            Alert.alert(errormsg)

            const idx = global.billBlacklist.findIndex((dataBill: Bill) => {
              return billID === dataBill.billID && supplierID === dataBill.supplierID && billDate === dataBill.billDate
            })

            if (idx >= 0) {
              global.billBlacklist.splice(idx, 1)
            }
          }
          resolve(result.data)
        })
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
  approve(
    token: string | undefined,
    url: string | undefined,
    mandantId: string | undefined,
    msgID: string,
    billID: string,
    supplierID: string,
    billDate: string,
    approved: boolean,
    comment: string
  ) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      myHeaders.append('Content-Type', 'application/json')

      let raw
      if (comment !== '') {
        raw = JSON.stringify({
          msgID: msgID,
          approved: approved ? 1 : 0,
          comment: comment,
          billId: billID,
        })
      } else {
        raw = JSON.stringify({
          msgID: msgID,
          approved: approved ? 1 : 0,
          billId: billID,
        })
      }

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
      }

      dontWaitResolve(billID, supplierID, billDate, resolve)

      fetch(url + '/Bills/approve', requestOptions)
        .then(response => response.json())
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  delegate(
    token: string | undefined,
    url: string | undefined,
    mandantId: string | undefined,
    msgID: string,
    billID: string,
    supplierID: string,
    billDate: string,
    employeeId: number,
    comment: string | undefined
  ) {
    return new Promise((resolve, reject) => {
      const myHeaders = createHeader(token, mandantId)
      myHeaders.append('Content-Type', 'application/json')

      let raw = ''
      if (comment !== '') {
        raw = JSON.stringify({
          msgID: msgID,
          billID: billID,
          comment: comment,
          employeeId: employeeId,
        })
      } else {
        raw = JSON.stringify({
          msgID: msgID,
          billID: billID,
          employeeId: employeeId,
        })
      }

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
      }

      dontWaitResolve(billID, supplierID, billDate, resolve)

      fetch(url + '/Bills/delegate', requestOptions)
        .then(response => response.json())
        .then(result => {
          resolve(result.data)
        })
        .catch(error => {
          console.error('error', error)
          reject(error)
        })
    })
  },
}

export default api
